import React from 'react';

import { GetLabelAndViewerQuery } from 'gql/graphql';

import LabelSubscribersTableDesktop from './LabelSubscribersTableDesktop';
// import RecommendedSubscriberList from './RecommendedSubscriberList';
import ConfirmArchiveAccessModal from './ConfirmArchiveAccessModal';
import ConfirmRemoveSubscriberModal from './ConfirmRemoveSubscriberModal';
import LabelSubscribersListMobile from './LabelSubscribersListMobile';
import {
  LabelSubscribersProvider,
  useLabelSubscribersContext
} from './LabelSubscribersContext';
import LabelSubscribersFilterControls from './LabelSubscribersFilterControls';
import NoSubscribersDisplay from './NoSubscribersDisplay';

const LabelSubscribersDisplay = () => {
  const { isSmallScreen } = useLabelSubscribersContext();
  return (
    <>
      <LabelSubscribersFilterControls />

      {isSmallScreen && <LabelSubscribersListMobile />}

      {!isSmallScreen && <LabelSubscribersTableDesktop />}

      <NoSubscribersDisplay />

      <ConfirmArchiveAccessModal />
      <ConfirmRemoveSubscriberModal />
    </>
  );
};

interface LabelSubscribersProps {
  label: NonNullable<GetLabelAndViewerQuery['label']>;
}

const LabelSubscribers = ({ label }: LabelSubscribersProps) => (
  <LabelSubscribersProvider label={label}>
    <LabelSubscribersDisplay />
  </LabelSubscribersProvider>
);

export default LabelSubscribers;
